import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import { Payment, PaymentDetail, PaymentCreate, PaymentUpdate } from '@core/types/finance.type';
import { PaginationResult, PaginationConfig } from './unit.service';
import { buildPaginationBody } from '@core/utils/pagination.util';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api}/finance/payments`;

  getPayments(config: PaginationConfig): Observable<ApiResponse<PaginationResult<Payment>>> {
    return this.http.post<ApiResponse<PaginationResult<Payment>>>(`${this.apiUrl}/grid`, buildPaginationBody(config));
  }

  getPayment(id: string): Observable<ApiResponse<PaymentDetail>> {
    return this.http.get<ApiResponse<PaymentDetail>>(`${this.apiUrl}/${id}`);
  }

  registerPayment(data: PaymentCreate): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(this.apiUrl, data);
  }

  updatePayment(data: PaymentUpdate): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(this.apiUrl, data);
  }

  deletePayment(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }
}
